import { Toast } from "@douyinfe/semi-ui";
import { WHITESPACES } from "@services/common/config/common.config";

interface SiteModel {
  prefix: string;
  start: number;
  startSuffix: string;
  end: number;
  endSuffix: string;
}

export function replaceWhitespace(text: string) {
  if (!text) return "";
  const newText = WHITESPACES.reduce((ac, c) => {
    const rx = new RegExp(c, "g");
    const t = ac.replace(rx, "");
    return t;
  }, text);

  return newText;
}

export function groupByChunks<T>(arr: T[], chunkSize = 50): T[][] {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}

export function parseRanges(rangeStr: string) {
  const ranges: SiteModel[] = [];
  const parts = rangeStr.split(",");

  parts.forEach((part) => {
    const match = part.match(/([A-Z]):(\d+)([A-Z]?)(?:-(\d+)([A-Z]?))?/);
    if (match) {
      const prefix = match[1];
      const start = parseInt(match[2], 10);
      const startSuffix = match[3] || "";
      const end = match[4] ? parseInt(match[4], 10) : start;
      const endSuffix = match[5] || startSuffix;
      ranges.push({ prefix, start, startSuffix, end, endSuffix });
    }
  });

  return ranges;
}

export function isInRanges(rangeStr: string, targetStr: string) {
  const targetRanges = parseRanges(targetStr);
  const validRanges = parseRanges(rangeStr);

  for (const {
    prefix: tPrefix,
    start: tStart,
    startSuffix: tStartSuffix,
    end: tEnd,
    endSuffix: tEndSuffix,
  } of targetRanges) {
    let inValidRange = false;
    for (const {
      prefix: vPrefix,
      start: vStart,
      startSuffix: vStartSuffix,
      end: vEnd,
      endSuffix: vEndSuffix,
    } of validRanges) {
      if (
        tPrefix === vPrefix &&
        tStart >= vStart &&
        tEnd <= vEnd &&
        tStartSuffix === vStartSuffix &&
        tEndSuffix === vEndSuffix
      ) {
        inValidRange = true;
        break;
      }
    }
    if (!inValidRange) return false;
  }

  return true;
}

export function checkDublicateFragment(text: string) {
  const fragments = text.split(",");
  const chains = fragments.map((fragment) => {
    return fragment[0];
  });
  const map: Record<string, string[]> = {};
  chains.forEach((chain) => {
    if (!map[chain]) {
      map[chain] = [chain];
    } else {
      map[chain].push(chain);
    }
  });

  const targetChain = Object.keys(map).find((chain) => {
    return map[chain].length > 1;
  });
  if (targetChain) {
    return map[targetChain];
  }
  return null;
}

export function validateSitesRange(
  antigen: string,
  epitope: string,
  type: "antigen" | "epitope"
): string {
  if (antigen && epitope) {
    const inRange = isInRanges(antigen, epitope);

    if (!inRange) {
      return "Epitope must lie in cropped antigen.";
    }
  }

  if (type === "antigen") {
    const duplicated = checkDublicateFragment(antigen);
    if (duplicated) {
      return `Chain ${duplicated[0]} contains ${duplicated.length} segments, but at most one is allowed.`;
    }
  }

  // if (type === "antigen") {
  //   if (!antigen) {
  //     return "Please select antigen";
  //   }
  // }

  // if (type === "epitope") {
  //   if (!epitope) {
  //     return "Please select epitope";
  //   }
  // }
  return "";
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function unsecuredCopyToClipboard(text: string) {
  const textArea = document.createElement("textarea");
  textArea.style.position = "absolute";
  textArea.style.left = "-9999px";
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand("copy");
    if (!successful) {
      console.error("Copy command was unsuccessful");
    }
  } catch (err) {
    console.error("Unable to copy to clipboard", err);
  }

  document.body.removeChild(textArea);
}

export const copyToClipboard = (content: string) => {
  console.log("copyToClipboard-->", content);
  if (window.isSecureContext && navigator.clipboard) {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        Toast.success("Copied");
      })
      .catch(() => {});
  } else {
    unsecuredCopyToClipboard(content);
    Toast.success("Copied");
  }
};
